export default __webpack_public_path__ + "static/media/me.2f48db82.png";